import React, { useState, useEffect } from 'react';
import { login } from '../../utils/auth';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuthApp } from '../../app/auth';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/login.css';
import QRCode from '../../../media/login/QR-code.png';
import wineBottle from '../../../media/login/wine-bottle.png';
import QRCodeBottle from '../../../media/login/QRCode_round_white.png';
import jwt_decode from 'jwt-decode';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Swal from "sweetalert2";


const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});


function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation(); // Initialize useTranslation
    const setUserAction = useAuthApp((state) => state.setUser); // Get the setUser action
    const isLoggedIn = useAuthApp((state) => state.isLoggedIn);
    const navigate = useNavigate();
    const location = useLocation();


    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);

    useEffect(() => {
        if(isLoggedIn){
            navigate('/dashboard')
        }
    }, [isLoggedIn])

    const resetForm = () => {
        setEmail("")
        setPassword("")
    }

    const handleLogin = async (e) => {
        e.preventDefault()
        setIsLoading(true)

        const { data, error } = await login(email, password);

        if (error) {
            alert(error)
            Toast.fire({
                icon: 'error',
                title: t("loginPage.messages.loginFailed") + ': ' + error
            })
            setIsLoading(false)
            return
        } else {
            navigate("/dashboard")
            resetForm()
            setIsLoading(false)
            return
        }
        setIsLoading(false)
    }

  return (
    <>
        <div className="form-container-1">
            <div className="form-inner-container-1">
                <div className="left-div-1">
                    <h2 className="font">{t("loginPage.headings.welcome")}</h2>
                    <p className="font">{t("loginPage.descriptions.createLabel")}</p>
                    <img
                        src={wineBottle}
                        alt="wine bottle"
                        className="wine-bottle-pic"
                    />
                    <img
                        src={QRCodeBottle}
                        alt="QR code"
                        className="qr-wine-bottle"
                    />
                </div>
                <div className="right-div-1">
                    <img
                        src={QRCode}
                        alt="QR Code"
                        className="icon-qr-code"
                    />
                    <p className="form-heading-1">{t("loginPage.headings.welcomeBack")}</p>
                    <p className="desc-text">{t("loginPage.descriptions.enterDetails")}</p>
                    <form onSubmit={handleLogin}>
                        <div className='form-input-container-1'>
                            <label className="form-label-1" htmlFor="username">{t("loginPage.labels.username")}</label>
                            <input id="username" className="form-input-1" type="text" name="username" value={email} onChange={(e) => setEmail(e.target.value)}/><br></br>
                        </div>
                        <div className='form-input-container-1'>
                            <label className="form-label-1" htmlFor="password">{t("loginPage.labels.password")}</label>
                            <input id="password" className="form-input-1" type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)}/><br></br>
                            <p className='font forgot-pw-link'>
                                <Link to="/forgot-password" className=''>{t("loginPage.links.forgotPassword")}</Link>
                            </p>
                            {location.state?.activationMessage && (
                                <div className="info-message">
                                    {t("loginPage.messages.accountActivation")}
                                </div>
                            )}
                        </div>

                        {isLoading 
                        ? <button disabled className="form-button-submit-1" type="submit">
                            <i className="fas fa-spinner fa-spin"></i>
                            <span className="mr-2">Processing</span>
                          </button>
                        : <button className="form-button-submit-1" type="submit"><span className="mr-2">Login</span>
                            {/* <i className="fas fa-sign-in" /> */}
                          </button>
                        }
                    </form>

                    <p className='font m-top-10px'>
                        {t("loginPage.links.account")} <Link className="sign-up-link" to="/register">{t("loginPage.links.signUp")}</Link>
                    </p>
                </div>
            </div>
        </div>
    </>
   
  )
}

export default Login